import { request } from '@umijs/max';
import { CommonResult } from '@/services/CommonType';

export type RewardType = 'TITLE' | 'BADGE' | 'ICON' | 'FRAME';

export type RewardItem = {
  rewardId?: number;
  rewardType?: RewardType;
  rewardName?: string;
  rewardIcon?: string;
  rewardDescription?: string;
  costPoints?: number;
  owned?: boolean;
  equipped?: boolean;
};

export type GamificationInfo = {
  levelNo?: number;
  experience?: number;
  nextLevelExperience?: number;
  pointBalance?: number;
  totalActiveMinutes?: number;
  todayActiveMinutes?: number;
  todayUsagePoints?: number;
  todayGamePoints?: number;
  equippedTitle?: RewardItem;
  equippedBadge?: RewardItem;
  equippedIcon?: RewardItem;
  equippedFrame?: RewardItem;
  rewards?: RewardItem[];
};

export type HeartbeatResult = {
  acceptedSeconds?: number;
  gainedExperience?: number;
  gainedPoints?: number;
  levelNo?: number;
  experience?: number;
  pointBalance?: number;
  todayActiveMinutes?: number;
};

export type GameScoreResult = {
  bestScore?: number;
  gainedPoints?: number;
  todayGamePoints?: number;
  pointBalance?: number;
};

export type GameCode = 'RAIDEN' | 'FROG_WORDS';

export type GameLeaderboardRank = {
  rank?: number;
  accountId?: number;
  accountName?: string;
  totalPoints?: number;
  bestScore?: number;
};

export type GameLeaderboardResult = {
  gameCode?: GameCode;
  topRanks?: GameLeaderboardRank[];
  myRank?: GameLeaderboardRank;
  onBoard?: boolean;
};

export async function getGamificationInit(options?: { [key: string]: any }) {
  return request<CommonResult<GamificationInfo>>('/api/home/gamification/init', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function submitGamificationHeartbeat(
  activeSeconds: number,
  options?: { [key: string]: any },
) {
  return request<CommonResult<HeartbeatResult>>('/api/home/gamification/heartbeat', {
    method: 'POST',
    data: { activeSeconds },
    ...(options || {}),
  });
}

export async function exchangeReward(rewardId: number, options?: { [key: string]: any }) {
  return request<CommonResult<GamificationInfo>>('/api/home/gamification/rewards/exchange', {
    method: 'POST',
    data: { rewardId },
    ...(options || {}),
  });
}

export async function equipReward(rewardId: number, options?: { [key: string]: any }) {
  return request<CommonResult<GamificationInfo>>('/api/home/gamification/rewards/equip', {
    method: 'POST',
    data: { rewardId },
    ...(options || {}),
  });
}

export async function submitGameScore(
  gameCode: GameCode,
  score: number,
  options?: { [key: string]: any },
) {
  return request<CommonResult<GameScoreResult>>('/api/home/gamification/game-score', {
    method: 'POST',
    data: { gameCode, score },
    ...(options || {}),
  });
}

export async function getGameLeaderboard(gameCode: GameCode, options?: { [key: string]: any }) {
  return request<CommonResult<GameLeaderboardResult>>('/api/home/gamification/game-leaderboard', {
    method: 'GET',
    params: { gameCode },
    ...(options || {}),
  });
}
